import type {
  CostSummaryResponse,
  CostSummaryViewModel,
  CostChartDataPointResponse,
  CostChartDataPointViewModel,
  CostTimeSeriesResponse,
  CostTimeSeriesViewModel,
  CostBreakdownItemResponse,
  CostBreakdownItemViewModel,
  CostBreakdownResponse,
  CostBreakdownViewModel,
} from "@models/cost";

export const buildCostSummaryViewModel = (
  response: CostSummaryResponse,
): CostSummaryViewModel => {
  return {
    totalCost: response.total_cost,
    currency: response.currency,
    eventCount: response.event_count,
    usersCount: response.users_count,
    dateRange: {
      startDate: response.date_range.start_date
        ? new Date(response.date_range.start_date)
        : null,
      endDate: response.date_range.end_date
        ? new Date(response.date_range.end_date)
        : null,
    },
  };
};

export const buildCostChartDataPointViewModel = (
  response: CostChartDataPointResponse,
): CostChartDataPointViewModel => {
  return {
    timestamp: new Date(response.timestamp),
    costAmount: response.cost_amount,
    eventCount: response.event_count,
    usersCount: response.users_count,
    currency: response.currency,
  };
};

export const buildCostTimeSeriesViewModel = (
  response: CostTimeSeriesResponse,
): CostTimeSeriesViewModel => {
  return {
    dataPoints: response.data_points.map(buildCostChartDataPointViewModel),
    totalCost: response.total_cost,
    currency: response.currency,
    granularity: response.granularity,
    dateRange: {
      startDate: new Date(response.date_range.start_date),
      endDate: new Date(response.date_range.end_date),
    },
  };
};

export const buildCostBreakdownItemViewModel = (
  response: CostBreakdownItemResponse,
): CostBreakdownItemViewModel => {
  return {
    dimensionValue: response.dimension_value,
    dimensionId: response.dimension_id,
    totalCost: response.total_cost,
    eventCount: response.event_count,
    usersCount: response.users_count,
    percentage: response.percentage,
    currency: response.currency,
  };
};

export const buildCostBreakdownViewModel = (
  response: CostBreakdownResponse,
): CostBreakdownViewModel => {
  return {
    breakdown: response.breakdown.map(buildCostBreakdownItemViewModel),
    totalCost: response.total_cost,
    currency: response.currency,
    dimension: response.dimension,
  };
};
